import React, { Component } from 'react';

import { Button, Tabs, Modal, Icon, Input, message } from 'antd';

import Crumbs from './../../../Crumbs/Crumbs';//面包屑
import TabPeople from './../CompanyListTab/TabPeople';//企业成员
import TabInformation from './../CompanyListTab/TabInformation';//企业信息
import TabIntroduce from './../CompanyListTab/TabIntroduce';//企业介绍

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件
import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import $ from "jquery"
import CompanyFristLogin from './../CompanyFristLogin/CompanyFristLogin';
import createHistory from 'history/createHashHistory';//路由切换地址
import CompanyModal from "./../CompanyModal/index"//组件携带参数“0”或者“1”，0为有切换用户，1无切换用户
import ChangeCompanyModal from "./../CompanyModal/changeCom"


import "./../style.css"
import { setTimeout } from 'core-js/library/web/timers';

const TabPane = Tabs.TabPane;
const history = createHistory();//定义history路由
//Tab组件

class Tab extends React.Component {
    state = {
        key: "1"
    }
    callback(key) {
        this.setState({
            key:key
        })
    }
    render() {
        return (
            <Tabs activeKey={this.state.key} onChange={this.changeValue}>
                <TabPane tab="企业成员" key="1"><TabPeople /></TabPane>
                <TabPane tab="企业信息" key="2"><TabInformation /></TabPane>
                <TabPane tab="品类管理" key="3"><TabIntroduce /></TabPane>
            </Tabs>
        )
    }
}




let _App
class App extends Component {
    state = {
        hei: 500,
        isAdmin: "block",
        key:'1'
    };

    //预设尺寸
    windowChangeSize() {
        let H = window.innerHeight - 229;
        this.setState({
            hei: H
        })
    }

    showModal() {
        this.props.dispatch(evn.showModal())
    }
    showModalChange() {
        this.props.dispatch({ type: "showModalCom" })
    }
    //解除绑定
    relieveBind() {
        _DelBind.showModal()
    }

    componentDidMount() {
        _App = this;
        this.windowChangeSize()
        if(localStorage.getItem('tabValue')=='2'){
            _App.setState({
                key:'2'
            })
        }
        EventSet.NavShow(this, "/Content/Business/CompanyList", "Business")//显示菜单
    }

    toList=()=>{
        history.push({
            pathname: "/Content/Business/CompanyList",
        })
    }
    changeValue=(e)=> {
        this.setState({
            key:e
        })
    }
    render() {

        return (
            <div id="BusinessCenter">
                <Crumbs title={"主体管理 / 主体设置"} />
                <CompanyModal type={"0"} />
                <ChangeCompanyModal />
               
                <div className="BusinessWrap" style={{ minHeight: this.state.hei }}>
                    <div className={"BusinessNews"}>
                        <div className={"BusinessTitle"}>
                            <p> <span style={{wordBreak:'break-all'}}>{JSON.parse(localStorage.getItem('companyInfo')).Com_Name}</span></p>
                            {/* <p>权限: <span>{EventSet.getUserInfo().UCR_IsAdmin === "0" ? "普通成员" : "管理员"}</span></p> */}
                        </div>
                        <div className={"BusinessBut"}>
                            {/* <DelBind />
                            <Button onClick={this.showModalChange.bind(this)}>切换企业</Button>
                            <Button onClick={this.showModal.bind(this)}>绑定/加入企业</Button>
                            <Button onClick={this.relieveBind} type="danger">解除绑定</Button> */}
                            <Button onClick={this.toList}>返回主体管理</Button>
                        </div>  
                    </div>
                    <div className={"BusinessTab"}>
                    <Tabs activeKey={this.state.key} onChange={this.changeValue}>
                            <TabPane tab="企业成员" key="1"><TabPeople /></TabPane>
                            <TabPane tab="企业信息" key="2"><TabInformation /></TabPane>
                            <TabPane tab="品类管理" key="3"><TabIntroduce /></TabPane>
                    </Tabs>
                    </div>
                </div>
            </div>

        );
    }
}
const mapStateToProps = (state) => {
    return {
        keys: state.TagKey,
    }
};

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/MainCenter/MainSubject.js